<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [secondaryButtonLabel]="secondaryButtonLabel" [modalHelpIndex]="modalHelpIndex"
    (closeButtonActionEmt)="closeModal()" [isPrimaryButtonHidden]="true" [modalClass]="modalClass"
    [resizeVertical]="true" [resizeVerticalMin]="500" [maximizable]="true" [resizeHorizontal]="true"
    [resizeHorizontalMin]="500">
    <div>
        <div *ngFor="let task of taskDetails" class="modal-fill">
            <div class="section-heading"
                [attr.data-automation-id]="'workbasket-task-details-'+task.currentStatusAutoId+'-value'">
                {{ task.name }}
            </div>
            <table class="table">
                <tbody>
                    <tr *ngFor="let data of task.data">
                        <td class="name">{{data.name}}</td>
                        <td class="value"><span [innerHTML]="data.value"
                                [attr.data-automation-id]="'workbasket-task-details-'+data.dataAutoId+'-value'"></span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</res-base-modal>